<div class="dialog-container">
    <mat-toolbar color="primary" class="dialog-toolbar">
        <span class="dialog-title">
            <mat-icon>pin_drop</mat-icon>
            Manage Locations
        </span>
        <button mat-icon-button (click)="onCancel()" class="close-button" aria-label="Close dialog">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>

    <div class="dialog-content" mat-dialog-content>
    <mat-tab-group class="location-tabs" animationDuration="0ms" (selectedTabChange)="onTabChange($event)">            <!-- Find and Assign Location Tab -->
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon>search</mat-icon>
                    Find & Assign Location
                </ng-template>
                <div class="tab-content">
                    <mat-card appearance="outlined">
                        <mat-card-header style="margin: 15px;">
                            <mat-card-title>Search Locations</mat-card-title>
                        </mat-card-header>
                        <mat-card-content>
                            <form [formGroup]="locationSearchForm" class="search-form">
                                <div class="form-grid">
                                    <mat-form-field appearance="outline">
                                        <mat-label>Area Name</mat-label>
                                        <mat-select formControlName="area" (selectionChange)="onAreaChange($event)">
                                            <mat-option value="">-- Select Area --</mat-option>
                                            <mat-option *ngFor="let area of data.areas" [value]="area.code">
                                                {{ area.value }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" *ngIf="locations.data.length > 0">
                                        <mat-label>Search available locations...</mat-label>
                                        <input matInput formControlName="searchText" (keyup)="applyFilter($event)"
                                            placeholder="Filter by name, block, etc.">
                                        <mat-icon matSuffix>search</mat-icon>
                                    </mat-form-field>
                                </div>
                                <div class="form-actions">
                                    <button mat-stroked-button type="button" (click)="resetLocationSearchForm()">
                                        <mat-icon>refresh</mat-icon>
                                        Reset
                                    </button>
                                </div>
                            </form>
                        </mat-card-content>
                    </mat-card>

                    <mat-card appearance="outlined" style="margin-top: 10px;" *ngIf="locationSearchForm.get('area')?.value">
                        <mat-card-header>
                            <mat-card-title>Available Locations</mat-card-title>
                        </mat-card-header>
                        <mat-card-content>
                            <div class="table-container">
                                <div *ngIf="isLoading" class="loading-container">
                                    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
                                </div>

                                <ng-container *ngIf="!isLoading">
                                    <div *ngIf="locations.data.length > 0; else noLocationsTemplate">
                                        <table mat-table [dataSource]="locations" class="mat-elevation-z2">
                                            <!-- Columns -->
                                            <ng-container matColumnDef="areaName">
                                                <th mat-header-cell *matHeaderCellDef>Area</th>
                                                <td mat-cell *matCellDef="let element">{{ element.areaName }}</td>
                                            </ng-container>
                                            <ng-container matColumnDef="locationName">
                                                <th mat-header-cell *matHeaderCellDef>Location</th>
                                                <td mat-cell *matCellDef="let element">{{ element.locationName }}</td>
                                            </ng-container>
                                            <ng-container matColumnDef="qtrNumber">
                                                <th mat-header-cell *matHeaderCellDef>Quarter</th>
                                                <td mat-cell *matCellDef="let element">{{ element.quarterNumber }}</td>
                                            </ng-container>
                                            <ng-container matColumnDef="blockNumber">
                                                <th mat-header-cell *matHeaderCellDef>Block</th>
                                                <td mat-cell *matCellDef="let element">{{ element.blockNumber }}</td>
                                            </ng-container>
                                            <ng-container matColumnDef="residentName">
                                                <th mat-header-cell *matHeaderCellDef>Assigned To</th>
                                                <td mat-cell *matCellDef="let element">
                                                    <span *ngIf="element.residentFirstName; else unassigned">
                                                        {{ element.residentFirstName }} {{ element.residentLastName }}
                                                    </span>
                                                    <ng-template #unassigned>
                                                        <span class="unassigned-text"></span>
                                                    </ng-template>
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="select">
                                                <th mat-header-cell *matHeaderCellDef class="text-center">Select</th>
                                                <td mat-cell *matCellDef="let element" class="text-center">
                                                    <mat-checkbox (change)="toggleSelection(element, $event.checked)"
                                                        [checked]="isSelected(element)"
                                                        aria-label="Select location">
                                                    </mat-checkbox>
                                                </td>
                                            </ng-container>
                                            <tr mat-header-row *matHeaderRowDef="displayedLocationsColumns"></tr>
                                            <tr mat-row *matRowDef="let row; columns: displayedLocationsColumns;"></tr>
                                        </table>
                                        <mat-paginator #availablePaginator [pageSize]="5" [pageSizeOptions]="[5, 10, 25]"
                                            showFirstLastButtons></mat-paginator>
                                    </div>
                                </ng-container>

                                <ng-template #noLocationsTemplate>
                                    <div class="no-data-message">
                                        <mat-icon>location_off</mat-icon>
                                        <p>No locations found for the selected area.</p>
                                    </div>
                                </ng-template>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
            </mat-tab>

            <!-- Add New Location Tab -->
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon>add_location_alt</mat-icon>
                    Add New Location
                </ng-template>
                <div class="tab-content">
                    <mat-card appearance="outlined" class="add-location-card">
                        <mat-card-header>
                            <mat-card-title>Create New Location</mat-card-title>
                        </mat-card-header>
                        <mat-card-content>
                            <form [formGroup]="newLocationForm" class="location-form">
                                <div class="form-grid">
                                    <mat-form-field appearance="outline">
                                        <mat-label>Area Name</mat-label>
                                        <mat-select formControlName="newArea" required>
                                            <mat-option *ngFor="let area of data.areas" [value]="area.code">
                                                {{ area.value }}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error
                                            *ngIf="newLocationForm.get('newArea')?.touched && newLocationForm.get('newArea')?.hasError('required')">
                                            Area is required.
                                        </mat-error>
                                    </mat-form-field>
                                    <mat-form-field appearance="outline">
                                        <mat-label>Location Type</mat-label>
                                        <mat-select formControlName="locationType" required>
                                            <mat-option *ngFor="let type of data.locationTypes" [value]="type.lookupCode">
                                                {{ type.lookupValue }}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error
                                            *ngIf="newLocationForm.get('locationType')?.touched && newLocationForm.get('locationType')?.hasError('required')">
                                            Location type is required.
                                        </mat-error>
                                    </mat-form-field>
                                    <mat-form-field appearance="outline">
                                        <mat-label>Quarter Number</mat-label>
                                        <input matInput formControlName="qtrNumber" required>
                                        <mat-error
                                            *ngIf="newLocationForm.get('qtrNumber')?.touched && newLocationForm.get('qtrNumber')?.hasError('required')">
                                            Quarter number is required.
                                        </mat-error>
                                    </mat-form-field>
                                    <mat-form-field appearance="outline">
                                        <mat-label>Block Number</mat-label>
                                        <input matInput formControlName="blockNumber" required>
                                        <mat-error
                                            *ngIf="newLocationForm.get('blockNumber')?.touched && newLocationForm.get('blockNumber')?.hasError('required')">
                                            Block number is required.
                                        </mat-error>
                                    </mat-form-field>
                                    <mat-form-field appearance="outline">
                                        <mat-label>Location Name</mat-label>
                                        <input matInput formControlName="locationName">
                                    </mat-form-field>
                                    <mat-form-field appearance="outline">
                                        <mat-label>Phone Number</mat-label>
                                        <input matInput formControlName="phoneNumber" type="tel" maxlength="10" pattern="[0-9]*">
                                        <mat-error
                                            *ngIf="newLocationForm.get('phoneNumber')?.touched && newLocationForm.get('phoneNumber')?.hasError('pattern')">
                                            Invalid 10-digit phone number.
                                        </mat-error>
                                    </mat-form-field>
                                    <mat-form-field appearance="outline">
                                        <mat-label>Location Code</mat-label>
                                        <input matInput formControlName="locationCode">
                                    </mat-form-field>
                                    <mat-form-field appearance="outline">
                                        <mat-label>Location Details</mat-label>
                                        <input matInput formControlName="locationDetails">
                                    </mat-form-field>
                                </div>
                                <div class="form-actions">
                                    <button mat-stroked-button (click)="resetNewLocationForm()">
                                        <mat-icon>refresh</mat-icon>
                                        Reset Form
                                    </button>
                                </div>
                            </form>
                        </mat-card-content>
                    </mat-card>
                </div>
            </mat-tab>
        </mat-tab-group>

        <!-- Assigned Locations - Always Visible -->
        <mat-card appearance="outlined" style="margin-top: 10px;">
            <mat-card-header>
                <mat-card-title>
                    Assigned Locations
                    <span class="location-count" *ngIf="getSelectedLocationsCount() > 0">
                        ({{ getSelectedLocationsCount() }} selected)
                    </span>
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div class="table-container" *ngIf="assignedLocations.data.length > 0; else noAssignedTemplate">
                    <table mat-table [dataSource]="assignedLocations" class="mat-elevation-z2">
                        <!-- Columns -->
                        <ng-container matColumnDef="areaName">
                            <th mat-header-cell *matHeaderCellDef>Area</th>
                            <td mat-cell *matCellDef="let element">{{ element.areaName }}</td>
                        </ng-container>
                        <ng-container matColumnDef="QuarterNo">
                            <th mat-header-cell *matHeaderCellDef>Quarter</th>
                            <td mat-cell *matCellDef="let element">{{ element.quarterNumber }}</td>
                        </ng-container>
                        <ng-container matColumnDef="blockNumber">
                            <th mat-header-cell *matHeaderCellDef>Block</th>
                            <td mat-cell *matCellDef="let element">{{ element.blockNumber }}</td>
                        </ng-container>
                        <ng-container matColumnDef="locationName">
                            <th mat-header-cell *matHeaderCellDef>Location</th>
                            <td mat-cell *matCellDef="let element">{{ element.locationName }}</td>
                        </ng-container>
                        <ng-container matColumnDef="locationAssignedTo">
                            <th mat-header-cell *matHeaderCellDef>Assigned to</th>
                            <td mat-cell *matCellDef="let element">{{ element.locationAssignedTo }}</td>
                        </ng-container>
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef>Status</th>
                            <td mat-cell *matCellDef="let element"
                                [ngClass]="'status-' + (element.status | lowercase | replace: ' ':'-')">
                                {{ element.status }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef class="text-center">Actions</th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <button mat-icon-button color="warn" (click)="removeLocation(element.id)"
                                    *ngIf="element.status !== 'Deleted'" aria-label="Remove location">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedAssignedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedAssignedColumns;"></tr>
                    </table>
                    <mat-paginator #assignedPaginator [pageSize]="5" [pageSizeOptions]="[5, 10, 25]"
                        showFirstLastButtons></mat-paginator>
                </div>
                <ng-template #noAssignedTemplate>
                    <div class="no-data-message">
                        <mat-icon>location_city</mat-icon>
                        <p>No locations have been assigned yet.</p>
                    </div>
                </ng-template>
            </mat-card-content>
        </mat-card>
    </div>

    <div class="dialog-actions" mat-dialog-actions>
        <button mat-stroked-button (click)="onCancel()">
            <mat-icon>cancel</mat-icon>
            Cancel
        </button>
        <button mat-flat-button color="primary" (click)="onAssign()" [disabled]="getSelectedLocationsCount() === 0" *ngIf="activeTabIndex === 0">
            <mat-icon>assignment_turned_in</mat-icon>
            Assign Selected ({{ getSelectedLocationsCount() }})
        </button>
        <button mat-flat-button color="primary" (click)="onSaveNewLocation()" [disabled]="newLocationForm.invalid" *ngIf="activeTabIndex === 1">
            <mat-icon>save</mat-icon>
            Add & Assign Selected ({{ getSelectedLocationsCount() }})
        </button>
    </div>
</div>